import React from 'react';
import './google-badge.m.css';
import { useSelector } from 'react-redux';
import { BQLink } from '../../atoms/bqlink';
import get from 'lodash/get';
import { clickPreferredSourceBadge } from '../../../helpers/datalayer-utils';

const GoogleBadge = ({ story = {}, isStory = false, position = '' }) => {
  const googleBadge = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'google_badge_content'], {}),
  );
  return (
    <div onClick={() => clickPreferredSourceBadge(story, position)}>
      <BQLink
        className="badge-container"
        styleName="badge-wrap"
        href={googleBadge?.link}
        target={googleBadge?.target || '_self'}
      >
        <div styleName="content">
          <div styleName="title">{isStory ? googleBadge?.storyTitle : googleBadge?.homeTitle}</div>
          <div styleName="sub-title">
            {isStory ? googleBadge?.storySubTitle : googleBadge?.homeSubTitle}
          </div>
        </div>
        <img src={googleBadge?.lightBadge} alt="Google Badge" styleName="img-badge" width="auto" />
        <img
          src={isStory ? googleBadge?.badgeLogo : googleBadge?.profitBadge}
          alt="Google Badge"
          height="80px"
          width="64px"
          styleName={isStory ? 'profit-badge story-logo' : 'profit-badge'}
        />
      </BQLink>
    </div>
  );
};

export default GoogleBadge;
